import { render, staticRenderFns } from "./DtSection.vue?vue&type=template&id=a0f0bd02&"
import script from "./DtSection.vue?vue&type=script&lang=js&"
export * from "./DtSection.vue?vue&type=script&lang=js&"
import style0 from "./DtSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports